export const buckarooGetOrderViewBase = ({ execute, setToken }) => {
    return async (orderId) => {
        const requestWithToken = await setToken({
            method: "GET",
            uri: `/ctp/order/${orderId}/order-view`,
        });
        return execute(requestWithToken);
    };
};
